import React from 'react';
import ReactDOM from 'react-dom/client';
import Body from './body/Body';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Body />
  </React.StrictMode>
);
